import React from 'react';
import { CTAButton } from './CTAButton';
import { PRICE } from './salesData';

/**
 * La ecuación del kit: recetas + tomos + recursos = kit.
 * Bloque de alto contraste que cierra el tramo de oferta.
 */
export function KitBoxSection() {
  return <section className="bg-ivory py-10 sm:py-14" aria-labelledby="kit-title" data-id="element-257" data-mp="8xv2vihb1kpp">
      <div className="mx-auto w-full max-w-6xl px-5 sm:px-8" data-id="element-258" data-mp="4xb46ah3291g">
        <div className="rounded-5xl bg-charcoal p-6 text-center sm:p-10" data-id="element-259" data-mp="3w4x17k9ard9c">
          <ul className="flex flex-wrap items-center justify-center gap-x-4 gap-y-3" data-id="element-260" data-mp="3w21603ou32ol">
            {['100 recetas', '2 tomos', '5 recursos para dar tus primeros pasos'].map((item, index) => <li key={item} className="flex items-center gap-4" data-id="element-261" data-mp="3i4md2ozdgcrv" data-mpi={index}>
                  {index > 0 && <span className="font-display text-lg text-[#F47A2A]" aria-hidden data-id="element-262" data-mp="1keky66k6ws4j">
                      +
                    </span>}
                  <span className="font-sans text-[0.72rem] font-bold uppercase tracking-[0.1em] text-white sm:text-[0.82rem]" data-id="element-263" data-mp="1ge11t57fxsjg">
                    {item}
                  </span>
                </li>)}
          </ul>

          <p id="kit-title" className="mx-auto mt-5 max-w-xl font-display text-[1.35rem] leading-snug text-white sm:text-[1.9rem]" data-id="element-264" data-mp="rn3awnej6zz0">
            = un kit mucho más completo para empezar
          </p>

          <div className="mt-7 flex flex-col items-center gap-3" data-id="element-265" data-mp="1jfarjnu1ecde">
            <p className="font-display font-display-black text-[2.4rem] leading-none tabular-nums text-white sm:text-[3rem]" data-id="element-266" data-mp="1odm0lwciciuk">
              <span className="align-top font-display text-sm font-bold text-[#F47A2A] sm:text-base" data-id="element-267" data-mp="1akmjxr0zoilf">
                {PRICE.currency}
              </span>
              {PRICE.current}
            </p>
            <CTAButton label="Quiero el kit completo" size="lg" className="w-full sm:w-auto" data-id="element-268" data-mp="22c265jymw3b4" />
          </div>
        </div>
      </div>
    </section>;
}